/*! js-cookie v3.0.1 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}return function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"})}));


/* Laboite Analytics */

window.Laboite = window.Laboite || {};

function getUserIP() {
  const ipData = $.getJSON('https://ipinfo.io/json?token=34dff609b13977', function(data) {
    console.log(data.ip);
    return data.ip;
  });

  return ipData;
}

function getSourceUrl() {
  return window.location.href;
}

function getUserAgent() {
  return navigator.userAgent;
}

function getFbParam() {
  return Cookies.get('_fbc');
}


function pushFbEvent({eventId, eventName, value, currency, source="website"}) {
  const pixelId = '1595280380597250';
  const accessToken = 'EAAPPZBkkwfY0BABQhLNks9i6PrzYZADXrzMxzpYfgoULq51hMK54ZAIwZCAw5JUqndf1cmxQLXznDT3ZBVD9x7YsDLfqHauBZAoPz0EiBgvQB1pEShTiwZAUWhOe1MX5iCkpXR3V7N0ccYgy0AfyD6on9UH1qVddjmvHNje7ZAgnyddzf6RbfHNp';
  const endpoint = `https://graph.facebook.com/v12.0/${pixelId}/events?access_token=${accessToken}`;

  getUserIP().then(function(data){

    const payload = {
       data: [{
         event_name: eventName,
         event_time: Math.round(Date.now()/1000), // timestamp in seconds
         event_id: eventId, // order number
         event_source_url: getSourceUrl(),
         action_source: source,
         user_data: {
            client_ip_address: data.ip,
            client_user_agent: getUserAgent(),
            fbc: Cookies.get('_fbc') || '',
            fbp: Cookies.get('_fbp') || ''
         },
         custom_data: {
            value: value,
            currency: currency
         }
      }]
    };

    $.post(endpoint, payload, function(result) {
      // console.log('payload sent', payload, result);
      console.log('sent');
    }, 'json');

  });

}

function triggerPageView() {
  let name = 'Page View';

  if (!Cookies.get('visited')) {
    name = 'First Visit';
    Cookies.set('visited', 1);
  }

  pushFbEvent({
    eventId: Math.round(Date.now()/1000),
    eventName: name,
    value: 0,
    currency: 'USD'
  });
}

triggerPageView();

// pushFbEvent();
window.Laboite.FBanalytics = {
 pushFbEvent: pushFbEvent
}


// sample
// {
//    "data": [
//       {
//          "event_name": "Purchase",
//          "event_time": 1633552688,
//          "event_id": "event.id.123",
//          "event_source_url": "http:\/\/jaspers-market.com\/product\/123",
//          "action_source": "website",
//          "user_data": {
//             "client_ip_address": "192.19.9.9",
//             "client_user_agent": "test ua",
//             "em": [
//                "309a0a5c3e211326ae75ca18196d301a9bdbd1a882a4d2569511033da23f0abd"
//             ],
//             "ph": [
//                "254aa248acb47dd654ca3ea53f48c2c26d641d23d7e2e93a1ec56258df7674c4",
//                "6f4fcb9deaeadc8f9746ae76d97ce1239e98b404efe5da3ee0b7149740f89ad6"
//             ],
//             "fbc": "fb.1.1554763741205.AbCdEfGhIjKlMnOpQrStUvWxYz1234567890",
//             "fbp": "fb.1.1558571054389.1098115397"
//          },
//          "custom_data": {
//             "value": 100.2,
//             "currency": "USD",
//             "content_ids": [
//                "product.id.123"
//             ],
//             "content_type": "product"
//          },
//          "opt_out": false
//       },
//       {
//          "event_name": "Purchase",
//          "event_time": 1633552688,
//          "user_data": {
//             "client_ip_address": "192.88.9.9",
//             "client_user_agent": "test ua2"
//          },
//          "custom_data": {
//             "value": 50.5,
//             "currency": "USD"
//          },
//          "opt_out": true
//       }
//    ]
// }
